import { LoginComponent } from './login.component';
import { Routes } from '@angular/router';

export const LoginRoutes: Routes = [
    {
      path: '', component: LoginComponent // path: '', component: LoginComponent
    }
];
